export default "__VITE_ASSET__DrxmHekh__"